import {IApplicationState} from '../../../../types/types';
import { APP_TEAM_EMAIL } from '../constants';
import {getAuthUser} from './getAuthUser';

export const isKanbanchiUser = (
    state: IApplicationState
): boolean => {
    // const kanbanReg = /@kanbanchi.com$/;
    const kanbanReg = /(@kanbanchi.com|@mail.magicwebsolutions.co.uk|@magicwebsolutions.co.uk)$/;
    const email = getAuthUser(state).email;

    let isKanbanchi = kanbanReg.test(email);
    if (isKanbanchi) {
        isKanbanchi = email !== APP_TEAM_EMAIL; // исключить аккаунт для демо
    }
    return isKanbanchi;
};
